import React, { Component } from 'react'
import CacheKeys from '../../../../cache/CacheKeys.js'
import CacheManager from '../../../../cache/CacheManager.js'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils.js'
import MappingListUI from './MappingListUI.js'

class MappingListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      propertyList: null,
      updateMode: false,
      createMode: false,
      selectedProperty: null
    }
  }

  render() {
{console.log('OS: ', this.props.totalOutStandingLoan)}
{console.log('OS: ', this.props.totalSecurityAmount)}
{console.log('OS: ', this.props.totalDsraCurrent)}
    return (
      <MappingListUI
        context={this.props.context}
        errorList={this.state.errorList}
        propertyList={this.state.propertyList}
        selectedProperty={this.state.selectedProperty}
        flag={this.props.flag}
        totalOutStandingLoan={this.props.totalOutStandingLoan}
        totalSecurityAmount={this.props.totalSecurityAmount}
        totalDsraCurrent={this.props.totalDsraCurrent}
        updateMode={this.state.updateMode}
        createMode={this.state.createMode}
        onCreateModeClick={() => {this.setState({createMode: true})}}
        onCreateCancelClick={() => {this.setState({createMode: false})}}
        category={this.props.category}
        categoryLabel={this.props.categoryLabel}
        // events
        onRefreshClick={this.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onUpdate={this.onUpdate}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProperties(context)
  }

  getProperties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/mappings/${this.props.category}`,
      cacheKey: CacheKeys.MappingGroup(this.props.category),
      callback: this.getPropertiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPropertiesCallback = (response) => {
    this.setState({errorList: response.errorList, propertyList : response.mappingList})
  }

  onUpdateClick = (event) => {
    let mappingId = event.currentTarget.getAttribute('data-property')
    console.log(mappingId);
    let selectedProperty = this.state.propertyList.filter(p => p.mappingId === mappingId)[0]
    this.setState({updateMode: true, selectedProperty: selectedProperty})
  }

  onCancelClick = () => {
    this.setState({updateMode:false, errorList: null})
  }

  onUpdate = (selectedProperty) => {
    CacheManager.removeObject(CacheKeys.MappingGroup(this.props.category))
    this.setState({propertyList : this.state.propertyList})
  }

  onRefreshClick = (noBusy) => {
    CacheManager.removeObject(CacheKeys.MappingGroup(this.props.category))
    if (noBusy === 'noBusy') {
      console.log('noBusy');
      this.getProperties(this.props.context)
    }
    else {
      this.setState(
        {
          propertyList: null,
          errorList: null,
        }, this.getProperties(this.props.context)
      )
    }
  }
}

export default MappingListSF
